module.exports = __webpack_public_path__ + "img/logo.10a85305.jpg";